import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqAndSubscribe() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [email, setEmail] = useState("");
  const [notice, setNotice] = useState("");

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  const handleSubscribe = () => {
    if (!email.trim()) {
      setNotice("先填一个能收到更新的邮箱吧。");
      return;
    }
    setNotice("已记录，更新提醒会在下期发布时送达。");
    setEmail("");
  };

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">FAQ</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              找不到入口、入口失效、不知道从哪开始，这几类问题问得最多，统一放在这里回答。
            </p>

            <div
              id="subscribe"
              className="mt-8 rounded-lg border border-foreground-950/12 bg-primary-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-notification-3-line text-lg"></i>
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  更新提醒
                </h3>
              </div>
              <p className="mt-3 text-sm leading-6 text-foreground-700">
                留下邮箱，新一期的获取方式与渠道入口更新后直接送达，不用自己反复找。
              </p>
              <div className="mt-4 flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="你的邮箱地址"
                  aria-label="订阅更新邮箱"
                  className="flex-1 px-4 py-3 rounded-md border border-foreground-950/15 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
                />
                <button
                  type="button"
                  onClick={handleSubscribe}
                  className="px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅更新
                </button>
              </div>
              {notice && (
                <p className="mt-3 flex items-center gap-2 text-sm text-secondary-900">
                  <i className="ri-information-line"></i>
                  {notice}
                </p>
              )}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-foreground-950/12">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className="border-b border-foreground-950/12">
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full border border-foreground-950/15 text-foreground-600 mt-0.5">
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <p className="pb-5 pr-8 text-sm md:text-base leading-7 text-foreground-600">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}